/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import _ from 'lodash';
window._ = _;

import vue from 'vue';
window.Vue = vue;

// vue globals
Vue.prototype.$website = window.website;

if (typeof (Stripe) !== 'undefined' && window.stripeKey)
    window.stripe = Stripe(window.stripeKey, { locale: window.locale });

Vue.filter("two_digits", function (value) {
    if (value.toString().length <= 1) {
        return "0" + value.toString();
    }
    return value.toString();
});

import { Settings } from 'luxon';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale });
import 'element-ui/lib/theme-chalk/index.css';

Settings.defaultLocale = window.locale;

import Datetime from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
    singleton: true
});

var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.use(require('vue-tippy'));

import VueMask from 'v-mask'
Vue.use(VueMask);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component("buy-tickets-button", require("./components/BuyTicketsButton.vue"));
Vue.component("seat-picker", require("./components/SeatPicker.vue"));
Vue.component("seat-picker-metadata-info", require("./components/SeatPicker/metadata-info.vue"));
Vue.component("svg-pan-and-zoom", require("./components/SVGPanAndZoom.vue"));
Vue.component("countdown", require("./components/Countdown.vue"));
Vue.component("countdown-minimal", require("./components/Countdown-minimal.vue"));
Vue.component("stripe-gateway", require("./components/Checkout/Gateway/Stripe.vue"));
Vue.component("apple-pay", require("./components/Checkout/Gateway/ApplePay.vue"));
Vue.component("auth", require("./components/Auth.vue"));
Vue.component("auth-trigger", require("./components/AuthTrigger.vue"));
Vue.component("auth-fixed", require("./components/AuthFixed.vue"));
Vue.component("auth-forgot", require("./components/AuthForgot.vue"));
Vue.component("search", require("./components/Search.vue"));
Vue.component("search-trigger", require("./components/SearchTrigger.vue"));
Vue.component("price", require("./components/Price.vue"));
Vue.component("checkout", require("./components/Checkout.vue"));

Vue.component("add-meta-to-cart", require("./components/Basket/Add-meta-to-cart.vue"));
Vue.component("remove-from-cart", require("./components/Basket/Remove-from-cart.vue"));
Vue.component("cart-item-qty", require("./components/Basket/Cart-item-qty.vue"));
Vue.component("basket-wrapper", require("./components/Basket/Basket-wrapper.vue"));

require("./components/Stadiums/all.js");

Vue.component('app-checkout-wrapper', require("./components/Checkout/Wrapper.vue"));
Vue.component('app-checkout-methods', require("./components/Checkout/Methods.vue"));
Vue.component('app-checkout-tickets', require("./components/Checkout/Tickets.vue"));
Vue.component('app-checkout-fields', require("./components/Checkout/Fields.vue"));
Vue.component('app-checkout-ticket-holders', require("./components/Checkout/TicketHolders.vue"));
Vue.component('app-checkout-summary', require("./components/Checkout/Summary.vue"));
Vue.component('identification-upload', require("./components/Checkout/Partials/Identification-upload.vue"));

Vue.component('protecht-widget', require("./components/Checkout/protecht/ProtechtWidget.vue"));

Vue.component('soundrink-auth-trigger', require("./components/Soundrink/soundrink-auth-trigger.vue"));
Vue.component('soundrink-nav-menu', require("./components/Soundrink/soundrink-nav-menu.vue"));

Vue.component('add-to-basket', require("./components/AddToBasket.vue"));

Vue.component('kendall-mountain-auth-trigger', require("./components/Tenants/kendall-mountain/kendall-mountain-auth-trigger.vue"));

Vue.component('kendall-mountain-search-trigger', require("./components/Tenants/kendall-mountain/kendall-mountain-SearchTrigger.vue"));

Vue.component('favourite-button', require("./components/Account/favourite-button.vue"));
Vue.component('address-button', require("./components/Account/address-button.vue"));
Vue.component('address-modal', require("./components/Account/address-modal.vue"));
Vue.component('countdown-continue-modal', require("./components/modals/countdown-continue-modal.vue"));
Vue.component('marketing', require("./components/Account/marketing.vue"));

Vue.component('google-address-autocomplete', require("./components/Fields/GoogleAddressAutocomplete.vue"));

Vue.component('package-selector', require("./components/package-selector.vue"));
Vue.component('newsletter-signup', require("./components/NewsletterSignup.vue"));

Vue.component('presale-ticket-card', require("./components/presale-ticket-card.vue"));
Vue.component('presale-count-down', require("./components/presale-count-down.vue"));

Vue.component("sound-rink-external-link-modal", require("./components/SoundRinkExternalLinkModal.vue"));
Vue.component("sound-rink-external-modal-button", require("./components/SoundRinkExternalModalButton.vue"));

import VModal from 'vue-js-modal'
Vue.use(VModal)
import './mixins/locale';

const app = new Vue({
    el: "#app",

    data: () => ({
        user: {
            opened: false
        },
        search: {
            opened: false
        },
        checkout: {
            paymentProcessing: false
        },
        buyTickets: {
            opened: ''
        },
        window: {
            width: 0,
            height: 0
        },
    }),
    computed: {
        isMobile() {
            if (this.window.width < 651) {
                return true;
            }
            return false;
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
});



// WEBPACK FOOTER //
// ./resources/js/app.js